module.exports = __webpack_public_path__ + "media/auth/login-background-2-b59a5fa4.jpg";